import React from "react";
import { Handle, Position } from "react-flow-renderer";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { CompareArrows } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  nodeContainer: {
    minWidth: 200,
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    background: "linear-gradient(135deg, #FF9800 0%, #FF6B35 100%)",
    boxShadow: "0 4px 12px rgba(255, 152, 0, 0.4)",
    border: "2px solid #FF9800",
    color: "white",
    position: "relative",
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 16px rgba(255, 152, 0, 0.5)",
    },
  },
  nodeHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  nodeIcon: {
    fontSize: 20,
  },
  nodeLabel: {
    fontWeight: 600,
    fontSize: 14,
    color: "white",
  },
  nodeCondition: {
    fontSize: 12,
    opacity: 0.95,
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(1),
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderRadius: 8,
    fontFamily: "monospace",
  },
  handle: {
    width: 12,
    height: 12,
    background: "white",
    border: "2px solid #FF9800",
    borderRadius: "50%",
  },
  handleTrue: {
    left: "50%",
    transform: "translateX(-50%)",
  },
  handleFalse: {
    right: 0,
  },
}));

const ConditionNode = ({ data, selected }) => {
  const classes = useStyles();
  const conditionText = data?.condition || data?.label || "Condición";

  return (
    <Box
      className={classes.nodeContainer}
      style={{
        boxShadow: selected
          ? "0 6px 20px rgba(255, 152, 0, 0.6)"
          : "0 4px 12px rgba(255, 152, 0, 0.4)",
      }}
    >
      <Handle
        type="target"
        position={Position.Top}
        className={classes.handle}
        style={{ top: -6 }}
      />
      <Box className={classes.nodeHeader}>
        <CompareArrows className={classes.nodeIcon} />
        <Typography className={classes.nodeLabel}>Condición</Typography>
      </Box>
      <Box className={classes.nodeCondition}>
        {conditionText.length > 40 ? `${conditionText.substring(0, 40)}...` : conditionText}
      </Box>
      <Handle
        type="source"
        position={Position.Bottom}
        id="true"
        className={`${classes.handle} ${classes.handleTrue}`}
        style={{ bottom: -6, left: "30%" }}
      >
        <Box
          style={{
            position: "absolute",
            bottom: -20,
            left: "50%",
            transform: "translateX(-50%)",
            fontSize: 10,
            fontWeight: 600,
            color: "#FF9800",
            backgroundColor: "white",
            padding: "2px 6px",
            borderRadius: 4,
            whiteSpace: "nowrap",
          }}
        >
          Sí
        </Box>
      </Handle>
      <Handle
        type="source"
        position={Position.Bottom}
        id="false"
        className={`${classes.handle} ${classes.handleFalse}`}
        style={{ bottom: -6, right: "30%" }}
      >
        <Box
          style={{
            position: "absolute",
            bottom: -20,
            right: "50%",
            transform: "translateX(50%)",
            fontSize: 10,
            fontWeight: 600,
            color: "#FF9800",
            backgroundColor: "white",
            padding: "2px 6px",
            borderRadius: 4,
            whiteSpace: "nowrap",
          }}
        >
          No
        </Box>
      </Handle>
    </Box>
  );
};

export default ConditionNode;
